
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import InformationsMarche from './informations-marche.vue';
import { FicheArticle } from '@/model/fiche-article';

import SelectionRegion from '@/components/selection-region.vue';
import { Analytics } from '@/plugins/analytics';
import { hasRole } from '@/utils/auth/has-role';
import { Roles } from '@/utils/auth/roles';
import { RouteName } from '@/router/routes';
import { Article } from '@/model/article';
import { CotationHistorique } from '@/model/cotation-historique';

import HeaderTdb from './header-tdb.vue';

type Variation = { idArticle: number, value: number }

export default Vue.extend({
  name: 'TableauDeBord',
  components: {
    InformationsMarche,
    SelectionRegion,
    HeaderTdb
  },
  data: () => ({
    loading: true as boolean,
    showInfo: false as boolean,
    variationArticles: [] as Variation[]
  }),
  computed: {
    ...mapGetters({
      articles: 'article/listeArticle',
      regionSelectionnee: 'user/regionSelectionnee',
      username: 'user/username',
      infoTiers: 'tiers/infosTiers'
      // versions: 'infos/versions'
    }),
    fichesArticlesSorted (): FicheArticle[] {
      return (this.articles as FicheArticle[]);
      // .slice()
      // .sort((a, b) => a.article.libelle.localeCompare(b.article.libelle) || a.article.commentaire.localeCompare(b.article.commentaire));
    }
  },

  created () {
    Analytics.setUserProperties({
      userType: hasRole(Roles.USER_ADHERENT) ? 'adherent' : 'agrial',
      username: this.username
    });

    this.loadListeArticle(this.regionSelectionnee ? this.regionSelectionnee.codeRegion : null)
      .then((articles: FicheArticle[]) => {
        for (const a of articles) {
          this.loadHistoriqueCotations({ idArticle: a.article.id })
            .then((cotations: CotationHistorique[]) => {
              const lastTwoCotations = cotations.slice(cotations.length - 2, cotations.length);
              if (lastTwoCotations.length > 0) {
                const variation = lastTwoCotations[1]?.valeur - lastTwoCotations[0]?.valeur;
                this.variationArticles.push({
                  idArticle: a.article.id,
                  value: variation
                });
              }
            });
        }
        // console.log('loadListeArticle', aa, this.articles, this.articles.map((a:any) => a.article));
      }).finally(() => {
        this.loading = false;
      });
  },
  watch: {
    regionSelectionnee () {
      this.loadListeArticle(this.regionSelectionnee ? this.regionSelectionnee.codeRegion : null);
    }

  },
  methods: {
    ...mapActions({
      loadListeArticle: 'article/loadListeArticle',
      loadHistoriqueCotations: 'cotations/loadHistorique'
    }),

    variationArticle (item: FicheArticle): Variation {
      return this.variationArticles?.find(a => a.idArticle === item.article.id);
    },
    goToDetail (unArticle: Article) {
      this.$router.push({ name: RouteName.MAIN_DETAIL, params: { idArticle: unArticle.toString() } });
    }
  }

});
